import SvgIcon from "./IconCamera.svg?react";
const IconCamera = SvgIcon;
export default IconCamera;
